module.exports = __webpack_public_path__ + "img/bladhna.6dd5089.webp";